/** EtherFi WithdrawRequestNFT — ERC-721 enumerable + per-id getter.
 *  Address on chain 1: `0x7d5706f6ef3f89b3951e23e557cdfbc3239d4e2c`. */
export const EtherFiWithdrawRequestAbi = [
  {
    name: 'balanceOf',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'tokenOfOwnerByIndex',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address' }, { type: 'uint256' }],
    outputs: [{ type: 'uint256' }],
  },
  {
    name: 'getRequest',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256', name: 'requestId' }],
    outputs: [
      {
        type: 'tuple',
        components: [
          { type: 'uint96', name: 'amountOfEEth' },
          { type: 'uint96', name: 'shareOfEEth' },
          { type: 'bool', name: 'isValid' },
          { type: 'uint32', name: 'feeGwei' },
        ],
      },
    ],
  },
  {
    name: 'isFinalized',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256' }],
    outputs: [{ type: 'bool' }],
  },
  {
    name: 'isValid',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'uint256' }],
    outputs: [{ type: 'bool' }],
  },
] as const
